module.exports = __webpack_public_path__ + "img/amex_white.f32a65e2.svg";